<template>
  <div class="page__wrapper" @scroll="onScroll()">
    <FCBenefits :h2="this.h2" :h3="this.h3" :benefits="this.benefits" />
  </div>
</template>

<script>
import FCBenefits from "@/components/patterns/FCBenefits";
export default {
  components: {
    FCBenefits
  },
  mounted() {
    const ref = this.$store.state.menu.firstFinancialClub.ref;
    const index = this.$store.state.menu.menuItems.map(e => e.ref).indexOf(ref);
    this.$store.state.menu.activeSection = index;
    this.$store.state.menu.currentSectionTitle = this.$store.state.menu.firstFinancialClub.title;
    this.$store.state.menu.currentSectionNavigation = this.$store.state.menu.firstFinancialClub.nav;
    this.onScroll();
  },
  data() {
    return {
      h2: "First Financial Club",
      h3: "Benefits",
      benefits: [
        {
          icon: "chair.png",
          text: `Lower level reserved seating along the stadium east side`
        },
        {
          icon: "beer.png",
          text: `Multiple taps featuring seasonal selections and mainstays from the local craft scene`
        },
        {
          icon: "private.png",
          text: `Private entrance and exclusive pre-game programming`
        },
        {
          icon: "pizza.png",
          text: `Multiple food options for purchase including artisan made-to-order pizzas`
        },
        {
          icon: "club.png",
          text: `Private indoor club`
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
.page__wrapper {
  background-image: url("~@/assets/backgrounds/bg-first-financial-intro.jpg");
  background-size: cover;
  background-position: center;
}
</style>